import { normalize, schema } from 'normalizr';
import type { Hour } from 'types/hour';
import type { HoursDetailsFilter } from 'types/hours';
import type { Project } from 'types/project';
import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { getFilterCount } from 'utils/report';
import type { State } from './user-page.types';
import * as types from './user-page.types';
import { initialState, xhrStatusModule } from './user-page.types';

const hourSchema = new schema.Entity('hours');

const hourArraySchema = new schema.Array(hourSchema);

interface HoursNormalized {
  entities: {
    hours: {
      [id: number]: Hour<Project>;
    };
  };
  result: Array<number>;
}

const reducer = reducerWithInitialState<State>(initialState)
  .caseWithAction(types.fetchedUserHours, (state, action): State => {
    const { entities, result }: HoursNormalized = normalize(action.payload.hours, hourArraySchema);
    return {
      ...state,
      hours: action.payload.append ? { ...state.hours, ...entities.hours } : entities.hours,
      result,
      filter: {
        ...state.filter,
        page:
          action.payload.hours.length >= state.filter.limit && action.payload.append
            ? state.filter.page + 1
            : initialState.filter.page,
      },
    };
  })
  .caseWithAction(types.setFilter, (state, action): State => {
    const newFilter: HoursDetailsFilter = {
      ...state.filter,
      ...action.payload,
    };
    newFilter.activeFilterCount = getFilterCount(newFilter);

    return {
      ...state,
      filter: newFilter,
    };
  })
  .caseWithAction(types.setDefaultFilters, (state, action): State => {
    const newFilter: HoursDetailsFilter = {
      ...state.filter,
      ...action.payload,
    };
    const filterCount = getFilterCount(newFilter);
    newFilter.activeFilterCount = filterCount;
    newFilter.defaultFilterCount = filterCount;
    return {
      ...state,
      filter: newFilter,
    };
  })
  .caseWithAction(types.setBatchSelection, (state, action): State => {
    let newSelection = { ...state.batchSelection, ...action.payload };
    // If no event are selected, reset
    if (!newSelection.eventIds.length) {
      newSelection = initialState.batchSelection;
    }

    return {
      ...state,
      batchSelection: newSelection,
    };
  })
  .case(types.resetBatchSelection, state => ({
    ...state,
    batchSelection: initialState.batchSelection,
  }))
  .case(types.reset, () => initialState);

export default xhrStatusModule.withXhrStatusReducer(reducer);
